import React from 'react'

import ChangeQuestionPerPageButton from '@components/Button/ChangeQuestionPerPageButton'
import FontSize from '@components/FontSize'
import Timer from '@components/Timer'
import CurrentDateTime from '@components/CurrentDateTime'
import { classNames } from '@lib/simpleFn'

type TimerHeaderProps = {
  showSubmitModal: boolean
  setShowSubmitModal: (trueFalse: boolean) => void
  viewResultMode: boolean
  groupTitle: string
  headerSubmitMode?: boolean
  setTimeout?: (truFalse: boolean) => void
  isTimerDisabled?: boolean
  userName: string
}

const TimerHeader: React.FC<TimerHeaderProps> = ({
  showSubmitModal,
  setShowSubmitModal,
  viewResultMode,
  groupTitle,
  headerSubmitMode,
  setTimeout,
  isTimerDisabled,
  userName,
}) => {
  const timerProps = {
    showSubmitModal,
    setShowSubmitModal,
    viewResultMode,
    headerSubmitMode,
    setTimeout,
  }

  const isTimerErased = isTimerDisabled || viewResultMode

  return (
    <>
      <div
        className={classNames(
          'sm:flex w-full sm:w-[1024px] lg:w-full font-bold bg-cbtLayout text-white text-base 1.1xl:text-lg sm:h-20 sm:items-center px-5 sm:px-1 py-4 sm:py-0 1.1xl:px-4 border-b border-dddddd',
          isTimerErased ? 'h-16' : 'h-32'
        )}
      >
        <div
          className={
            'hidden sm:flex bg-bosalpim w-12 h-12 1.1xl:w-14 1.1xl:h-14 justify-center font-bold text-[24px] 1.1xl:text-[28px] rounded-full mr-2 1.1xl:mr-3'
          }
        >
          <span className={'my-auto'}>01</span>
        </div>
        <div className={'hidden sm:flex flex-col'}>
          <span>응시번호: 0123</span>
          <span>성명: {userName}</span>
        </div>
        <div
          className={
            'exam-title flex-shrink mx-auto font-bold text-2xl pb-3 sm:pb-0 sm:text-xl 1.1xl:text-2.6xl whitespace-nowrap overflow-x-auto'
          }
        >
          {groupTitle}
        </div>
        {headerSubmitMode || viewResultMode ? (
          <div className={'hidden sm:flex'}>
            <CurrentDateTime />
          </div>
        ) : (
          <div className={'hidden sm:flex'}>
            <FontSize />
            <div className={'mx-3 1.1xl:mx-4 h-11 border border-dddddd'} />
            <ChangeQuestionPerPageButton />
          </div>
        )}

        {!isTimerErased && <Timer {...timerProps} />}
      </div>
    </>
  )
}

export default React.memo(TimerHeader)
